import React, { useState } from 'react';
import './DeliveryPartners.css';
import grubhubLogo from '../assets/images/grubhub.png';
import doordashLogo from '../assets/images/doordash.png';
import uberLogo from '../assets/images/uber.png';

function DeliveryPartners() {
  const [hoveredPlatform, setHoveredPlatform] = useState(null);

  const platforms = [
    { name: 'Grubhub', url: 'https://www.grubhub.com/restaurant/indo-nepal-culinary-fusion-1033-w-glebe-rd-alexandria/13221448', logo: grubhubLogo },
    { name: 'DoorDash', url: 'https://www.doordash.com/store/indo-nepal-culinary-fusiion-alexandria-40243369/93928232/?pickup=true', logo: doordashLogo },
    { name: 'UberEats', url: 'https://www.ubereats.com/store/indo-nepal-culinary-fusion-1033-w-glebe-rd/vfS69A5fVySB4Kmfwla4gA?diningMode=PICKUP&sc=SEARCH_SUGGESTION', logo: uberLogo },
  ];

  return (
    <section id="delivery-partners" style={styles.partnersSection} className="partners-section">
        <div style={styles.partnersContainer} className="partners-container">
        <p style={styles.partnersText} className="partners-text">
          To ensure convenient ordering and secure transactions, kindly choose one of our trusted ordering partners.
        </p>
        
        <div style={styles.logosGrid} className="logos-grid">
          {platforms.map((platform) => (
            <a
              key={platform.name}
              href={platform.url}
              target="_blank"
              rel="noopener noreferrer"
              className="logo-link"
              style={{
                ...styles.logoLink,
                ...(hoveredPlatform === platform.name ? styles.logoLinkHover : {})
              }}
              onMouseEnter={() => setHoveredPlatform(platform.name)}
              onMouseLeave={() => setHoveredPlatform(null)}
            >
              <div 
                className="logo-card"
                style={{
                  ...styles.logoCard,
                  ...(hoveredPlatform === platform.name ? styles.logoCardHover : {})
                }}
              >
                <img 
                  src={platform.logo} 
                  alt={platform.name} 
                  style={styles.logoImage}
                  className="logo-image"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default DeliveryPartners;

const styles = {
  partnersSection: {
    background: '#f5f5f7',
    padding: '4rem 2rem',
    borderTop: '1px solid #e5e5e5',
  },
  partnersContainer: {
    maxWidth: '1200px',
    margin: '0 auto',
    textAlign: 'center',
  },
  partnersText: {
    fontSize: '1.1rem',
    color: '#2c2c2c',
    marginBottom: '3rem',
    lineHeight: 1.6,
    fontWeight: 400,
  },
  logosGrid: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '2rem',
    flexWrap: 'wrap',
  },
  logoLink: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    transition: 'all 0.3s ease',
  },
  logoLinkHover: {
    transform: 'translateY(-5px)',
  },
  logoCard: {
    background: '#ffffff',
    padding: '2rem 3rem',
    borderRadius: '16px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: '#e5e5e5',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '200px',
    minHeight: '100px',
    cursor: 'pointer',
  },
  logoCardHover: {
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
    borderColor: '#1565c0',
    transform: 'scale(1.02)',
  },
  logoImage: {
    maxWidth: '180px',
    maxHeight: '70px',
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
  },
};

